import React from 'react';
import DashboardLayout from '../Dashboard/DashboardLayout';
import Patients from '../Patients/Patients';
import Appointments from '../Appointment/Appointment';
import Billing from '../Billing/Billing';
import Schedule from '../Schedule/Schedule';
import Settings from '../Settings/Settings';
import RevenueReports from '../RevenueReports/RevenueReports';
import './Layout.css';
import { visibleMenuLabels } from '../../lib/permissions';

const Layout = ({
    user,
    activeMenu,
    onNavigate,
    branches,
    selectedBranchId,
    onBranchChange,
}) => {
    const renderContent = () => {
        switch (activeMenu) {
            case 'Dashboard':
                return <DashboardLayout onNavigate={onNavigate} branches={branches} selectedBranchId={selectedBranchId} onBranchChange={onBranchChange} />;
            case 'PatientRecords':
                return <Patients branches={branches} selectedBranchId={selectedBranchId} onBranchChange={onBranchChange} />;
            case 'Schedule':
                return <Schedule branches={branches} selectedBranchId={selectedBranchId} onBranchChange={onBranchChange} />;
            case 'Appointments':
                return <Appointments branches={branches} selectedBranchId={selectedBranchId} onBranchChange={onBranchChange} />;
            case 'Billing':
                return <Billing branches={branches} selectedBranchId={selectedBranchId} onBranchChange={onBranchChange} />;
            case 'Settings':
                return (
                    <Settings
                        user={user}
                        branches={branches}
                        selectedBranchId={selectedBranchId}
                        onBranchChange={onBranchChange}
                    />
                );
            case 'RevenueReports':
                return <RevenueReports branches={branches} selectedBranchId={selectedBranchId} onBranchChange={onBranchChange} />;
            default:
                return (
                    <>

                    </>
                );
        }
    };

    if (user && visibleMenuLabels(user).length === 0) {
        return (
            <div className="layout">
                <main className="layout-content layout-no-access">
                    <p className="layout-no-access-message">
                        You do not have access to any modules. Contact your administrator.
                    </p>
                </main>
            </div>
        );
    }

    return (
        <div className="layout">

            {/* Main Content */}
            <main className="layout-content">
                {renderContent()}
            </main>
        </div>
    );
};

export default Layout;
